import { ChatSituations } from '../../../../../../../utils/fuctions/mapSituationChat';

const filterByTag = (chatCurrent, filters) => {
  if (!chatCurrent || !filters) return false;
  if (!filters['TAG']?.length) return false;
  if (
    filters['TAG']?.length &&
    (!chatCurrent?.tags || !chatCurrent?.tags?.length)
  )
    return false;
  let exists = false;
  const tags = chatCurrent?.tags || [];

  tags.forEach((tag) => {
    if (exists) return true;
    if (tag) {
      if (filters['TAG'].includes(tag)) exists = true;
      else exists = false;
    }
  });

  return exists;
};

const filterActiveContact = (chat, filters) => {
  if (!filters['START_TYPE']?.length) return false;
  if (filters['START_TYPE'] === 'ACTIVE' && chat.isContatoAtivo) return true;
  if (filters['START_TYPE'] === 'RECEPTIVE' && !chat.isContatoAtivo)
    return true;
  return false;
};

const filterByQueue = (chat, filters) => {
  const queues = filters['FILA'];
  if (!queues.length) return false;
  if (queues.includes(chat?.fila)) return true;
  return false;
};

export const filterConversation = (chat, str) => {
  if (!str) return true;

  const cliente = chat.cliente;

  if (!cliente) return false;

  const searchStr = str.toLowerCase();

  const clienteProps = Object.keys(cliente);

  return clienteProps.some((prop) => {
    const excludedFields = [
      'id',
      'was_created_automatically',
      'account_id',
      'created_at',
      'created_by',
      'last_updated_at',
      'last_updated_by',
      'record_type_id',
      'latitude',
      'longitude'
    ];

    if (excludedFields.includes(prop)) return false;

    const handleCpfCnpjInputSearch = (input) => {
      return input.replace('-', '').replace('.', '').replace('/', '');
    };

    return typeof cliente[prop] === 'string'
      ? cliente[prop]
          .toLowerCase()
          .includes(handleCpfCnpjInputSearch(searchStr))
      : false;
  });
};

const filterBySaved = (chat, filters, chatsSaved) => {
  if (filters['CHATS_SAVED']) return chatsSaved?.has(chat.id);
  return false;
};

const filterChatWithoutAgentInteractionWarning = (chat, filters) => {
  if (filters['INTERACTION_AGENT_WARNING']) {
    if (chat.situacao !== ChatSituations.IN_ATTENDANCE) return true;
    return chat.statusOfChat === 'AgentWarning';
  }

  return false;
};

const filterChatWithoutAgentInteractionCritical = (chat, filters) => {
  if (filters['INTERACTION_AGENT_CRITICAL']) {
    if (chat.situacao !== ChatSituations.IN_ATTENDANCE) return true;
    return chat?.statusOfChat === 'AgentCritical';
  }

  return false;
};

const filterChatWithResponseAgent = (chat, filters) => {
  if (filters['CHATS_WITH_RESPONSE_AGENT']) {
    if (chat.situacao !== ChatSituations.IN_ATTENDANCE) return true;
    return chat?.withResponseAgent;
  }

  return false;
};

const filterChatWithoutCustomerInteraction = (chat, filters) => {
  if (filters['INTERACTION_CLIENT']) {
    if (chat.situacao !== ChatSituations.IN_ATTENDANCE) return true;
    return chat.statusOfChat === 'CustomerCritical';
  }

  return false;
};

const filterByStatus = (chat, filters) => {
  const statusFilter = filters['STATUS'];
  if (!statusFilter || statusFilter.length === 0) return false;

  return statusFilter.some((status) => {
    switch (status) {
      case 'READ':
        return chat.novas_mensagens === 0;
      case 'UNREAD':
        return chat.novas_mensagens > 0;
      case 'IN_ATTENDANCE':
      case 'em_atendimento':
        return (
          chat.status === 'IN_ATTENDANCE' || chat.status === 'em_atendimento'
        );
      case 'WAITING_FOR_ANSWER':
      case 'aguardando_resposta':
        return (
          chat.status === 'WAITING_FOR_ANSWER' ||
          chat.status === 'aguardando_resposta'
        );
      default:
        return false;
    }
  });
};

export const filterss = (chat, filters, search, chatsSaved) => {
  if (chat?.situacao === ChatSituations.WAITING_IN_QUEUE) return false;
  return (
    filterActiveContact(chat, filters) ||
    filterByQueue(chat, filters) ||
    filterBySaved(chat, filters, chatsSaved) ||
    filterChatWithoutAgentInteractionCritical(chat, filters) ||
    filterChatWithoutAgentInteractionWarning(chat, filters) ||
    filterByTag(chat, filters) ||
    filterChatWithResponseAgent(chat, filters) ||
    filterByStatus(chat, filters) ||
    filterChatWithoutCustomerInteraction(chat, filters)
  );
};
